export default "__VITE_ASSET__Byeo21E$__"